import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import gsap from "@/plugins/gsap.js";
import VueRecaptcha from "vue-recaptcha";
import LoadScript from "vue-plugin-load-script";
import axios from "axios";
import moment from "moment";

import VueGtm from "vue-gtm";
import VueGtag from "vue-gtag";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import { SAFEGUARD_SITE_TITLE, isSafeguardHost } from "@/assets/js/safeguardSite";

import "fullpage.js/dist/fullpage.css";

Vue.config.productionTip = false;

// 세이프가드 홈페이지는 브라우저 탭 제목을 서비스명으로 쓴다 (index.html 은 핀브릿지 공용)
if (isSafeguardHost()) {
  document.title = SAFEGUARD_SITE_TITLE;
}

Vue.use(LoadScript);
Vue.use(gsap);

Vue.prototype.$cfg = { recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY };
Vue.prototype.axios = axios;
Vue.prototype.moment = moment;

Vue.loadScript("https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit")
  .then(() => {
    Vue.component("vue-recaptcha", VueRecaptcha);
  })
  .catch((e) => {
    console.error(`google api load failed: ${e.message}`);
  });

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_KEY,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: router
});

Vue.use(VueGtag, {
  config: {
    id: "G-1SDECHSDXM"
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");

